export default __webpack_public_path__ + "static/media/ColorHCPOnboarding.f84ede0c.svg";